import { Link } from 'react-router-dom'
import { Card } from '../../components/ui/Card'
import { EmptyState } from '../../components/ui/EmptyState'

/** Aviso de recurso do plano Premium em diante, no lugar do conteúdo. */
export function BloqueioPremium({ recurso }: { recurso: string }) {
  return (
    <Card>
      <EmptyState
        icon="ri-vip-crown-line"
        message={`${recurso} faz parte do plano Premium em diante.`}
        action={<Link to="/plano" className="inline-flex h-[38px] items-center gap-2 rounded bg-primary/10 px-4 text-13 font-medium text-primary hover:bg-primary hover:text-bg">Ver planos</Link>}
      />
    </Card>
  )
}
